import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import DateFormat from "../DateFormat";

const SmallNew = ({
  title,
  image,
  date,
  id,
  championship,
}: {
  title: string;
  image: string;
  date?: string;
  id: string;
  championship: string | null;
}) => {
  const { t } = useTranslation();
  const titleH3 = useRef<HTMLHeadingElement>(null);
  const navigate = useNavigate();

  return (
    <div
      className="news-item"
      onClick={() => {
        navigate(
          `${t("routes:News")}/${
            championship == null ? "LVF1" : championship.replace(/ /g, "")
          }/${id}`,
        );
      }}
    >
      <img className="imagen" src={image} alt={title} />
      <div className="contenido">
        <span className="category">
          {championship == null ? t("General") : championship}
        </span>
        <h3 ref={titleH3} className="texto">
          {title}
        </h3>
        {date != null && <DateFormat date={[date]} format={"short_year"} />}
      </div>
    </div>
  );
};

export default SmallNew;
